<template>
	<div class="tcp-page tcp-about">
		<section class="tcp-about__wrap">
			<p class="tcp-kicker">Our Story</p>
			<div v-if="body" class="tcp-about__body" v-html="body"></div>
			<p v-else-if="!loading" class="tcp-empty">This page has not been written yet.</p>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			body: '',
			loading: true
		}
	},
	mounted() {
		axios.get(tools.url('/api/store/about')).then((response) => {
			this.body = (response.data && response.data.body) || ''
			this.loading = false
		}).catch(() => {
			this.loading = false
		})
	}
}
</script>
